import "@theme/front/init.scss";

import "bootstrap/js/dist/dropdown";
import "bootstrap/js/dist/collapse";

import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel";

import "lightbox2/dist/css/lightbox.css";
import lightbox from "lightbox2/dist/js/lightbox";

import {initScroll} from "@/front/scroll";
import {onScroll} from "@/front/navbar";

document.addEventListener("DOMContentLoaded", () => {
	const navbar = $(".navbar");

	if (window.innerWidth <= 992) {
		$(".slide").css("height", window.innerHeight);
	}

	window.addEventListener("scroll", function () {
		onScroll();
	});

	initScroll();
	onScroll();

	lightbox.option({
		wrapAround: true,
		showImageNumberLabel: false
	});

	$(".navbar-toggler").off("click").on("click", function () {
		const isShown = $(this).hasClass("collapsed");

		if (isShown) {
			navbar.addClass("navbar-shown");
		} else {
			navbar.removeClass("navbar-shown");
		}
	});

	$(".gallery-carousel").owlCarousel({
		items: 1,
		margin: 0,
		loop: true,
		autoplay: true,
		autoplayTimeout: 4000,
		autoplaySpeed: 1000,
		autoplayHoverPause: true,
		dots: true,
		nav: true,
		navText : [
			"<img alt='Šipka - Doleva' src='" + window.app.baseUri + "/dist/img/icon/chevron-left.svg'' />",
			"<img alt='Šipka - Doprava' src='" + window.app.baseUri + "/dist/img/icon/chevron-right.svg' />",
		],
	});
});
